<template>
  <div class="xiaoliuren" v-if="mounted">
    <h2 class="title">小六壬测算</h2>
    <div class="form-group">
      <select v-model="selected1" class="form-select">
        <option disabled value="">请选择月份</option>
        <option
          v-for="option in selectedOptions_m"
          :key="option"
          :value="option"
        >
          {{ option + "月" }}
        </option>
      </select>

      <select v-model="selected2" class="form-select">
        <option disabled value="">请选择日期</option>
        <option
          v-for="option in selectedOptions_d"
          :key="option"
          :value="option"
        >
          {{ option + "日" }}
        </option>
      </select>

      <select v-model="selected3" class="form-select">
        <option disabled value="">请选择时辰</option>
        <option
          v-for="option in selectedOptions_h"
          :key="option"
          :value="option"
        >
          {{ option + "时" }}
        </option>
      </select>
    </div>
    <button class="calculate-btn" @click="handleClick">开始测算</button>
    <p class="result">结果: {{ resultShow.join("-") }}</p>
    <pre class="introduce">{{ currentRhymes }}</pre>
  </div>
</template>

<script>
import rhymesMap from "@/texture";
export default {
  name: "XiaoLiuRen",
  data() {
    return {
      selected1: "",
      selected2: "",
      selected3: "",
      mounted: false,
      list: ["大安", "留连", "速喜", "赤口", "小吉", "空亡"],
      result: [],
      resList: [],
      selectedOptions_m: Array.from({ length: 12 }, (_, i) => i + 1),
      selectedOptions_d: Array.from({ length: 31 }, (_, i) => i + 1),
      selectedOptions_h: [
        "子(23~1)",
        "丑(1~3)",
        "寅(3~5)",
        "卯(5~7)",
        "辰(7~9)",
        "巳(9~11)",
        "午(11~13)",
        "未(13~15)",
        "申(15~17)",
        "酉(17~19)",
        "戌(19~21)",
        "亥(21~23)",
      ],
    };
  },
  computed: {
    resultShow() {
      return this.result.map((item) => this.list[item]);
    },
    currentRhymes() {
      if (this.result.length === 0) return "";
      const results = this.resultShow.map((item) => {
        return rhymesMap[item];
      });

      return results.join("\n\n");
    },
  },
  methods: {
    handleClick() {
      if (!this.selected1 || !this.selected2 || !this.selected3) {
        alert("请完整选择月份、日期和时辰！");
        return;
      }

      this.result = [];
      let selected_H = this.selectedOptions_h.indexOf(this.selected3) + 1;
      this.resList = [this.selected1, this.selected2, selected_H];
      this.result[0] = this.findNumbers(this.resList[0]);
      this.result[1] = this.findNumbers(this.resList[1], this.result[0]);
      this.result[2] = this.findNumbers(this.resList[2], this.result[1]);
    },
    findNumbers(count, initial = 0) {
      return (initial + count - 1) % this.list.length;
    },
  },
  mounted() {
    this.mounted = true; // 确保组件完全挂载
  },
};
</script>

<style lang="less" scoped>
.xiaoliuren {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  text-align: center;
}

.title {
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-select {
  width: 100%;
  height: 40px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.form-select:focus {
  border-color: #4caf50;
  box-shadow: 0 0 6px rgba(76, 175, 80, 0.3);
}

.calculate-btn {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  background-color: #4caf50;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.calculate-btn:hover {
  background-color: #45a049;
}

.result {
  margin-top: 20px;
  font-size: 18px;
  color: darkviolet;
}

.introduce {
  margin-top: 20px;
  font-size: 14px;
  color: red;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  line-height: 1.6;
  display: flex;
  justify-content: space-around;
}

/* 响应式设计 */
@media (max-width: 600px) {
  .xiaoliuren {
    max-width: 100%;
    padding: 16px;
  }

  .title {
    font-size: 20px;
  }

  .form-select {
    font-size: 14px;
  }

  .calculate-btn {
    font-size: 14px;
  }

  .result {
    font-size: 16px;
  }

  .introduce {
    font-size: 12px;
  }
}
</style>
